<template>
    <div>
        <div class="albums">
            <h2>Album / Single</h2>
            <div class="content-area">
                <div
                    class="my-item"
                    v-for="album in sortByRelease(albums)"
                    :key="album.id"
                >
                    <div class="left">
                        <div class="title">{{ album.name }}</div>
                        <div class="release-date">release {{ dateFormat(album.release) }}</div>
                    </div>
                    <div class="right slot-container">
                        <div
                            :class="['item-slot', {active: spec.have}]"
                            v-for="spec in buildSpec(album.id, album.spec)"
                            :key="spec.id"
                        >
                            {{ spec.name }}
                        </div>
                    </div>
                </div>
            </div>
            <h2>Concerts</h2>
            <div class="content-area">
                <div
                    class="my-item"
                    v-for="con in sortByRelease(concerts)"
                    :key="con.id"
                >
                    <div class="left">
                        <div class="title">{{ con.name }}</div>
                        <div class="release-date">release {{ dateFormat(con.release) }}</div>
                    </div>
                    <div class="right slot-container">
                        <div
                            :class="['item-slot', {active: spec.have}]"
                            v-for="spec in buildSpec(con.id, con.spec)"
                            :key="spec.id"
                        >
                            {{ spec.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import misc from '@/data/misc.js';

export default {
    name: "Private",
    data: function() {
        return {
            albums: misc.albums,
            concerts: misc.concerts,
            magazines: misc.magazines,
            videos: misc.videos,
            photoBooks: misc.photoBooks,
            goods: misc.goods,
            ets: misc.etc,
        }
    },
    methods: {
        buildSpec( idPrefix, specMap ) {
            let specs = [];
            for ( const [ item, have ] of Object.entries( specMap ) ) {
                specs.push({
                    id: idPrefix + item,
                    name: item,
                    have: have,
                });
            }
            return specs;
        },
        dateFormat( releaseDateString ) {
            if ( releaseDateString.length === 8 ) {
                const yyyy = releaseDateString.slice(0,4);
                const mm = releaseDateString.slice(4,6);
                const dd =releaseDateString.slice(6,8);
                return yyyy.concat( '.', mm, '.', dd );
            } else if ( releaseDateString.length === 6 ) {
                const yyyy = releaseDateString.slice(0,4);
                const mm = releaseDateString.slice(4,6);
                return yyyy.concat( '.', mm );
            } else {
                return releaseDateString;
            }
        },
        sortByRelease( items ) {
            // let items = data.slice();
            items = items.sort((a, b) => {
                return Number( b.release ) - Number( a.release );
            })
            return items;
        },
    },
}
</script>

<style lang="scss" scoped>
.albums {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.content-area {
    display: flex;
    // flex-direction: column;
    width: 80%;
    flex-wrap: wrap;
}

.my-item {
    border: 1px solid gray;
    padding: 5px;
    display: flex;
    margin: 10px;
    width: 30%;
    min-width: 300px;
    .title {
        font-weight: bold;
        margin: 10px 5px;
    }
    .release-date {
        color: #5f7ba8;
        font-size: 0.9em;
    }
    .left {
        background-color: #edeff5;
        margin-right: 5px;
    }
    .left, .right {
        flex: 1;
    }
}

.slot-container {
    display: flex;
    flex-direction: column;
}

.item-slot {
    height: 60px;
    background-color: gray;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 5px;
}
.item-slot.active {
    background-color: #3ac7ff;
}
.item-slot:not(:last-child) {
    margin-bottom: 5px;
}

</style>
